// AI Employee Tour
// Voice AI, Conversation AI, Knowledge Base, Agent Templates and Content AI
// Selector policy: step 1 pins to the LIVE-VERIFIED sidebar id ([id="sb_AI Agents"]); the teaching steps are
// deliberate centered cards — no guessed element selectors (a wrong spotlight is worse than none).

export const aiEmployeeTour = {
  id: 'ai-employee',
  name: 'AI Employee Tour',
  displayName: 'Put Your AI Employee To Work',
  description: 'Voice AI, Conversation AI, Knowledge Base, Agent Templates and Content AI',
  estimatedDuration: '5 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: {
    animate: true,
    overlayOpacity: 0.75,
    smoothScroll: true,
    allowClose: true,
    showProgress: true
  },

  steps: [
    {
      element: '[id="sb_AI Agents"]',
      popover: {
        title: "🤖 Meet Your AI Employee",
        description: `
          Your AI employee answers, qualifies, books, and follows up — day and night, without a salary. Let us meet the team members you can hire.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "💬 Conversation AI",
        description: `
          **Conversation AI** replies to inbound messages like a trained rep: answers questions, qualifies the lead, and books the appointment straight into your calendar.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📞 Voice AI",
        description: `
          **Voice AI** picks up the phone. It talks to callers in natural speech, answers what it knows, and routes or books the rest — so no call goes to voicemail.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📚 Knowledge Base",
        description: `
          AI is only as good as what it knows. Feed the **knowledge base** your pricing, policies, and FAQs, and every agent answers accurately instead of guessing.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧩 Agent Templates",
        description: `
          Do not start from scratch. **Agent templates** are ready-made setups for common jobs — booking, qualifying, answering — with prompts and flows already built.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "✍️ Content AI",
        description: `
          **Content AI** writes with you: emails, funnel copy, social posts, images. It drafts, you refine — instead of staring at a blank page.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "⚙️ Workflow AI",
        description: `
          Drop AI **inside an automation**: summarize a conversation, score a lead, choose the next step. The workflow does the routing; the AI does the thinking.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📋 Agent Logs & Review",
        description: `
          Trust needs proof. **Agent logs** show every AI conversation — what was asked, what it answered — so you can review, correct, and improve.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your AI Team Is Hired",
        description: `
          You now know the AI stack:

✅ Conversation AI and Voice AI on the front line
✅ A knowledge base that keeps answers accurate
✅ Templates to launch in minutes
✅ Content AI and Workflow AI behind the scenes

**Next:** load your FAQs into the knowledge base, then launch one agent from a template.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
